import { XMarkIcon } from "@heroicons/react/24/solid";
import { integerName } from "../../../app/utils";
import { UserRole } from "../../../app/userSlice";
import { AlertLevel } from "../../../components/AlertMessage";
import ButtonWithConfirm from "../../../components/ButtonWithConfirm";
import {
	useRemoveProctorFromCoursesMutation,
	useRemoveWriterFromCoursesMutation,
} from "../../courses/coursesApiSlice";
import { UserCourseViewModel } from "../usersApiSlice";

interface RemoveFromCoursesProps {
	selectedCourses: UserCourseViewModel[];
	isLoading: boolean;
	name: string;
	userId: number;
	role: UserRole;
	resetTable: () => void;
	setIsLoading: (loading: boolean) => void;
}

export default function RemoveUserFromCourses(props: RemoveFromCoursesProps) {
	const length = props.selectedCourses.length;

	const [removeWriterFromCourses] = useRemoveWriterFromCoursesMutation();
	const [removeProctorFromCourses] = useRemoveProctorFromCoursesMutation();

	function handleRemove() {
		props.setIsLoading(true);
		const mutation =
			props.role === UserRole.Writer
				? removeWriterFromCourses({
						courseIds: props.selectedCourses.map((course) => course.courseID),
						writerId: props.userId,
					})
				: removeProctorFromCourses({
						courseIds: props.selectedCourses.map((course) => course.courseID),
						userId: props.userId,
					});

		mutation
			.unwrap()
			.catch((error) => {
				console.error(`Error removing user from courses:`, error);
			})
			.finally(() => {
				props.resetTable();
			});
	}

	return (
		<ButtonWithConfirm
			id="remove-from-courses-button"
			className="btn btn-neutral"
			disabled={length == 0 || props.isLoading}
			message={`Are you sure you want to remove ${props.name} from the ${length == 1 ? "selected course" : `${integerName(length)} selected courses`}?`}
			type={AlertLevel.Warning}
			confirmLabel="Yes"
			cancelLabel="No"
			onConfirm={handleRemove}>
			<XMarkIcon className="h-4 inline mr-2" />
			Remove
		</ButtonWithConfirm>
	);
}
